module.exports = __webpack_public_path__ + "img/user_img_placeholder.81acc606.svg";